import { render, staticRenderFns } from "./AddMethod.vue?vue&type=template&id=adf97b44&lang=pug"
import script from "./AddMethod.vue?vue&type=script&lang=js"
export * from "./AddMethod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports